import $ from '../../scripts/jquery-2.2.0';
import rr from '../../scripts/radresponder';

export const post = async(endpoint, payload) => await $.ajax({
    url: `${rr.getApiAddress()}${endpoint}`,
    type: "POST",
    contentType: "application/json",
    dataType: "json",
    data: JSON.stringify(payload)
});